import { CoreLogService } from "../../core/services/log.service";
import { orderTypes } from "../../core/shared/contentTypes";
import { ScheduledForRequest } from "../../core/shared/models";
import * as Models from '../models';

/** Interface für ein Webgutschein */
export interface ISOTVoucher {
  /** Webgutschein Nummer */
  readonly Code: string;
  /** Wert auf dem Webgutschein */
  readonly Amount: number;
  /** Einladungsbetrag (wird als erster aufgebraucht) */
  readonly InviteAmount: number;
  /** Webgutschein Rabatt */
  readonly Discount: number;
  /** Nimmt am Bonussystem teil */
  readonly UseBonussystem: boolean;
  /** Letzte Action mit den Bonuspunkten durch Webgutschein */
  readonly LastPointAction: string;
  /** Teilnehmende Bonusaktionen */
  readonly BonusActions: ReadonlyArray<ISOTVoucherBonusAction>;
}

/** Interface für eine Bonusaction */
export interface ISOTVoucherBonusAction {
  /** ID der Bonusaction */
  readonly ID: number;
  /** Bezeichnung der Bonusaction */
  readonly Name: string;
  /** Gesammelte Punkte */
  readonly Points: number;
  /** Enthaltene Benefits */
  readonly Benefits: ReadonlyArray<ISOTVoucherBonusActionBenefit>;
}

/** Interface für einen Benefit */
export interface ISOTVoucherBonusActionBenefit {
  /** Bezeichnung vom Benefit */
  readonly Name: string;
  /** Kosten für den Benefit */
  readonly PointsCost: number;
}

/** Interface für die Barrierefreiheitseinstellungen */
export interface ISOTAccessabilty {
  /** Gibt an, ob Modus Eins aktiviert ist */
  readonly useModeOne: boolean;
  /** Aktiviert oder deaktiviert Modus Eins */
  SetModeOne(active: boolean): void;

  /** Gibt an, ob Modus Zwei aktiviert ist */
  readonly useModeTwo: boolean;
  /** Aktiviert oder deaktiviert Modus Zwei  */
  SetModeTwo(active: boolean): void;
}

/** Interface zum unterbinden der Warnung über ein Cirkelbezug */
export interface ISOTService {

  /** Logservice, damit andere es nicht initieren müssen */
  readonly coreLogService: CoreLogService;

  /** initialisiert das SOT
   * @param location Location des SOT
   * @param port Port zum localen WebSocket des SOT
   * @param payAtTerminal ermöglicht das Zahlen am EC-Terminal
   * @param payAtPOS ermöglicht das Zahlen am POS
   * @param payAtCard ermöglicht das Zahlen mit Vorgangskarte
   * @param allowVoucherPay ermöglicht das Zahlen mit Webgutschein
   * @param useBonussystem ermöglich Bonussystem zu verwenden, ohne mit Webgutschein zahlen zu müssen
   * @param reset bereinigt den Speichet der Location
   * @param menu_concept stellt die Adfrage Preise als Menü Preise dar
   * @param pager_length bestimmt die Länge der Pagernummer
   * @param in_house_sortiment ermöglich das überschreiben vom in_house_sortiment (ist es leer wird es nicht überschrieben)
   * @param pickup_sortiment ermöglich das überschreiben vom pickup_sortiment (ist es leer wird es nicht überschrieben)
   * @param in_house_pe ermöglich das überschreiben vom in_house_pe (ist es leer wird es nicht überschrieben)
   * @param pickup_pe ermöglich das überschreiben vom pickup_pe (ist es leer wird es nicht überschrieben)
   */
  init(location: number, port: number, payAtTerminal: boolean, payAtPOS: boolean, payAtCard: boolean, allowVoucherPay: boolean, useBonussystem: boolean, reset: boolean, menu_concept: boolean, pager_length: number, in_house_sortiment: string, pickup_sortiment: string, in_house_pe: number, pickup_pe: number): void;

  /** momentan angewandte Benutzer Preisebene */
  GetUserPE(): number;

  /** momentan angewandter bestelltyp */
  GetOrderType(): orderTypes;

  /** momentan ausgewählte sprache */
  GetCurrentLanguage(): string;

  /** momentan angewandte Preisebene */
  GetServicePE(): number;

  /** momentan gesetzter Barrierefreier Modus */
  readonly Accessabilty: ISOTAccessabilty;

  /** momentan besten Discount in vollen Prozent */
  GetBestDiscountPercent(): number;

  /** prüft ob der artikel verfügbar ist */
  AvailabilityIsProductAvailable(productID: number): boolean;

  /** Zeitsteuerung */
  scheduleReqForRecomendationProduct(): ScheduledForRequest;
  /** number als betrag ausgeben (beachtet auch die Sprache) */
  formatCurrency(value: number, hasSymbol: boolean, useGrouping: boolean): string;

  //** momentan enthaltene Produkte im Warenkorb */
  GetNewProductBasket(product: Models.SOTProductViewModel): Models.SOTBasketViewModel;

  //** momentan enthaltener Warenkorb */
  GetBasket(): Models.SOTBasketViewModel;

  //** Gibt die Artikel TAGs zu den übergebenen IDs zurück */
  GetProductTagsByIds(tagsIds: number[]): Models.SOTProductTagViewModel[];

  //** get benefit product details */
  getBenefitProduct(benefitProductId: number): Models.SOTProductViewModel | null;
  //** sot settings */
  GetSettings(): Models.SOTSettingsViewModel;

  //** Aktuell angewandter Artikel TAG Filter */
  GetProductTagFilter(): number[];

  //** check whether the user reseted tag filter for single extra */
  isResetTagFilterActive(extraId: number): boolean;

  /** user can confirm to reset tag filter for single extra*/
  openResetExtraTagFilter(): Promise<boolean>;

  /** set list of extra IDs for resetting the tag filter */
  setResetTagFilterExtraIds(extraId: number): number[];

  //** übersetzt die langkey */
  TranslateKeyToLanguage(language: string, langkey: string): string;

  //** momentane Sprache */
  GetCurrentLanguage(): string;
  /** validate age */
  validateAgeRequirement(product: Models.SOTProductViewModel): Promise<boolean>;

  useModeOne(): boolean;
  setUseModeOne(value: boolean): void;

  /** Is the menu concept active for view, so that extra is shown as menu */
  isMenuConceptViewActive(): boolean;

  /** Releases the redemption of a removed single-use coupon line ($21) */
  SOTConnectionSendReleaseCoupon(redemptionId: string): void;

  /** wird der pfand schon im artikel preis angezeigt */
  readonly deposit_view: boolean;

  /** Offener restbetrag (wenn teilzahlung, z.B. mit Gutschein erfolgt) */
  readonly remainingAmount: number;

  /** gewährtes Trinkgeld in Prozent */
  readonly tipPercentage: number;

  /** zahlung mit Webgutschein ist erlaubt */
  readonly allowVoucherPay: boolean;

  /** Bonussystem wird eingesetzt und berücksichtigt */
  readonly useBonussystem: boolean;

  /** Bonussystem wird eingesetzt und berücksichtigt */
  readonly useInHouseSortiment: string;

  /** Bonussystem wird eingesetzt und berücksichtigt */
  readonly usePickupSortiment: string;

  /** Es wird am SOT erlaubt das InHouse zu nutzen */
  readonly hasInHouseOption: boolean;

  /** Es wird am SOT erlaubt das Pickup zu nutzen */
  readonly hasPickupOption: boolean;

  /** zahlung am ecTerminal ist erlaubt */
  readonly payAtTerminal: boolean;

  /** zahlung an dam POS ist erlaubt */
  readonly payAtPOS: boolean;

  /** eingescannter Webgutschein */
  readonly voucher: ISOTVoucher;

  /** eingescannter Webgutschein wird zum Zahlen verwendet */
  voucherSelectedForPay: boolean;
  /** Opens the "coupon already in cart" dialog; callback receives true when the user chooses to go to the basket. */
  openCouponInCartDialog(callback: (goToBasket: boolean) => void): void;

}

/** Outcome states for a coupon-redeem attempt (covers both 3–8-digit and 9-digit paths). */
export enum CouponRedeemResult {
  Done = "done",
  Cancelled = "cancelled",
  CodeNotValid = "code_not_valid",
  ProductNotAvailable = "product_not_available",
  AlreadyInCart = "already_in_cart",
  Error = "error",
  /** the wait for the POS was interrupted (reset by the inactivity dialog or guest left the scan page), callers must not continue the flow */
  Interrupted = "interrupted",
}

/** Result of the POS validation of a single-use code ($20) */
export interface ISOTCouponValidation {
  readonly success: boolean;
  readonly redemption_id?: string;
  readonly coupon_id?: string;
  /** Contract $20: artikel_nr of the article */
  readonly article_nr?: string;
  /** log only — the guest always sees the same generic message (no oracle) */
  readonly error?: string;
}

export enum VoucherActionType {
  /** redeem benefit */
  RedeemBenefit = "redeem_benefit",
  /** pay with voucher or collect points */
  PayOrCollect = "pay_or_collect"
}

/** SOT Dialog  */
export enum SOTDialogResult {
  Back = 'back',
  ScanCoupon = 'scan_coupon',
  RedeemBenefit = 'redeem_benefit'
}

